export function h1Title() {
   return `
   padding: 1%; 
   margin: 2% 4% 2% 4%; 
   font-weight: 400;
   font-size:1.6rem;
   color:#1d1d1d;
  `;
}


// WEBPACK FOOTER //
// ./src/styled_share.js